import { useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ItemMaster } from '../../../model/masters.model';
import { IField } from '../../../interfaces/field.interface';
import { parseFixed } from '../../../services/formats';
import { Fields } from '../../../components/Fields';
import { SaleOrderItemModel } from '../../../model/sale-order.model';


interface IOwnProps {
  items: Array<ItemMaster>;
  defaultData?: SaleOrderItemModel;
  show: boolean;
  handleClose: () => void;
  handleSubmit: (item: SaleOrderItemModel) => void;
}
const SaleOrderItemModal: React.FC<IOwnProps> = (props: IOwnProps) => {

  const { register, handleSubmit, control, reset, setValue, watch } = useForm<SaleOrderItemModel>({
    defaultValues: {},
    mode: "onTouched",
    reValidateMode: "onChange"
  });

  const item = watch("item");
  const qty = watch("qty");
  const rate = watch("rate");

  const itemChanged = () => {
    const selectedItem = props.items.find(t => t.id === item?.id);
    let net_rate = parseFixed(selectedItem?.rate) ?? 0;
    setValue("rate", parseFixed(net_rate));
  };

  const fields: Array<IField> = [
    {
      label: "Item",
      required: true,
      props: {
        name: "item",
        type: "typeahead",
        placeholder: "Item"
      },
      onChange: itemChanged,
      options: props.items,
    }, {
      label: "Qnty (Kgs)",
      required: true,
      props: {
        name: "qty",
        type: "number",
        placeholder: "Qnty (Kgs)"
      }
    }, {
      label: "Rate",
      required: true,
      props: {
        name: "rate",
        type: "number",
        placeholder: "Rate"
      }
    }, {
      label: "Amount",
      required: true,
      props: {
        name: "amt",
        type: "number",
        placeholder: "Amount",
        readOnly: true,
      },
    }
  ];

  useEffect(() => {
    reset(props.defaultData);
    return () => {
      reset();
    }
  }, [reset, props.defaultData]);

  useEffect(() => {
    let net_rate = parseFixed(rate) ?? 0;
    const amt = qty && net_rate ? parseFixed(qty * net_rate) : 0;
    setValue("amt", parseFixed(amt));
  }, [qty, rate, setValue]);

  const onSubmit = handleSubmit(async (inputs) => {
    props.handleSubmit(inputs);
    handleClose();
  });

  const handleClose = () => {
    reset();
    props.handleClose();
  };
  return (
    <Modal
      show={props.show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Form onSubmit={onSubmit} noValidate>
        <Modal.Header className="bg-primary-subtle" closeButton>
          <Modal.Title>Item Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Fields fields={fields} control={control} register={register} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">Add to List</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SaleOrderItemModal;